module.exports = __webpack_public_path__ + "img/logooo.87b9e3ac.png";